/**
 * MAISON ELIRA — RITUAL CARDS FOR SHRINE
 * =======================================
 * INSTALLATION:
 * 1. Shopify Admin → Online Store → Themes → Edit code
 * 2. Assets → Add a new asset → Create blank file → name it: ritual-cards.js
 * 3. Paste this entire file
 * 4. In Layout → theme.liquid, find </body> and add ABOVE it:
 *    <script src="{{ 'ritual-cards.js' | asset_url }}" defer></script>
 *
 * HOW IT WORKS:
 * - Finds Shrine's native pill buttons for your "Ritual" option
 * - Builds beautiful card UI on top, visually replacing the pills
 * - When a card is clicked → clicks the real hidden pill button
 * - Shrine's own JS handles everything: variant ID, price, image, ATC
 * - Zero interference with Shrine's variant system
 */

(function () {
  'use strict';

  // ── CONFIG ─────────────────────────────────────────────────
  // The name of your variant option EXACTLY as in Shopify
  var OPTION_NAME = 'Ritual';

  // Card data: key = variant value (EXACT match), value = card config
  // Edit descriptions and icons here
  var CARD_DATA = {
    'Maison Elira™ Massage Ritual Duo': {
      icon:  '🤲',
      desc:  'Deep-tissue release meets aromatic luxury.',
      badge: 'Best Seller'
    },
    'Maison Elira™ Sculpting Ritual Duo': {
      icon:  '✦',
      desc:  'Lift, define and restore natural contour.'
    },
    'Maison Elira™ Pore Sculptor': {
      icon:  '◈',
      desc:  'Refine texture and minimise pores.',
      badge: 'New'
    }
  };
  // ── END CONFIG ─────────────────────────────────────────────

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function buildCards(optionContainer, pillButtons) {
    // Remove any previously built cards (for theme editor reloads)
    var existing = optionContainer.querySelector('.ritual-cards-wrap');
    if (existing) existing.remove();

    var wrap = document.createElement('div');
    wrap.className = 'ritual-cards-wrap';

    // Eyebrow
    var eyebrow = document.createElement('p');
    eyebrow.className = 'ritual-cards-eyebrow';
    eyebrow.textContent = 'Select Your Ritual';
    wrap.appendChild(eyebrow);

    pillButtons.forEach(function (pill) {
      var value     = pill.textContent.trim();
      var config    = CARD_DATA[value] || {};
      var isSelected = pill.classList.contains('active') ||
                       pill.getAttribute('aria-pressed') === 'true' ||
                       pill.classList.contains('selected') ||
                       pill.classList.contains('is-selected');
      var isSoldOut  = pill.classList.contains('disabled') ||
                       pill.classList.contains('sold-out') ||
                       pill.disabled ||
                       pill.getAttribute('aria-disabled') === 'true';

      var card = document.createElement('div');
      card.className = 'ritual-card-item' +
        (isSelected ? ' is-selected' : '') +
        (isSoldOut  ? ' is-sold-out'  : '');
      card.setAttribute('role', 'button');
      card.setAttribute('aria-label', value);
      card.setAttribute('tabindex', isSoldOut ? '-1' : '0');
      card.dataset.value = value;

      // Badge
      if (config.badge) {
        var badge = document.createElement('span');
        badge.className = 'ritual-card-badge';
        badge.textContent = config.badge;
        card.appendChild(badge);
      }

      // Check icon
      var check = document.createElement('span');
      check.className = 'ritual-card-check';
      check.innerHTML = '<svg viewBox="0 0 14 14" fill="none"><path d="M3 7L5.5 9.5L11 4.5" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      card.appendChild(check);

      // Icon
      var icon = document.createElement('span');
      icon.className = 'ritual-card-icon';
      icon.textContent = config.icon || '✦';
      card.appendChild(icon);

      // Content
      var content = document.createElement('div');
      content.className = 'ritual-card-content';

      var title = document.createElement('span');
      title.className = 'ritual-card-title';
      title.textContent = value;
      content.appendChild(title);

      if (config.desc) {
        var desc = document.createElement('span');
        desc.className = 'ritual-card-desc';
        desc.textContent = config.desc;
        content.appendChild(desc);
      }

      card.appendChild(content);

      // Price — try to read from pill's data attributes (Shrine sets these)
      var priceWrap = document.createElement('div');
      priceWrap.className = 'ritual-card-price-wrap';

      var priceEl = document.createElement('span');
      priceEl.className = 'ritual-card-price';

      // Shrine stores price in data-price (in cents) on the button or nearby
      var priceData    = pill.dataset.price    || pill.dataset.variantPrice;
      var compareData  = pill.dataset.comparePrice || pill.dataset.variantComparePrice;

      if (priceData) {
        priceEl.textContent = formatMoney(parseInt(priceData, 10));
        if (compareData && parseInt(compareData, 10) > parseInt(priceData, 10)) {
          var compareEl = document.createElement('span');
          compareEl.className = 'ritual-card-compare';
          compareEl.textContent = formatMoney(parseInt(compareData, 10));
          priceWrap.appendChild(priceEl);
          priceWrap.appendChild(compareEl);
        } else {
          priceWrap.appendChild(priceEl);
        }
      }

      card.appendChild(priceWrap);

      // Shimmer
      var shimmer = document.createElement('span');
      shimmer.className = 'ritual-card-shimmer';
      card.appendChild(shimmer);

      // ── CLICK: trigger the real Shrine pill ──
      function activate() {
        if (isSoldOut) return;
        // Click the real native pill — Shrine handles the rest
        pill.click();
        // Update card visuals immediately (Shrine will also update its pills)
        optionContainer.querySelectorAll('.ritual-card-item').forEach(function (c) {
          c.classList.remove('is-selected');
        });
        card.classList.add('is-selected');
      }

      card.addEventListener('click', activate);
      card.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); activate(); }
      });

      wrap.appendChild(card);
    });

    // Insert our cards right before the hidden pills container
    var pillsContainer = optionContainer.querySelector(
      '.variant-picker__option-values--pills, [data-option-values]'
    );
    if (pillsContainer) {
      optionContainer.insertBefore(wrap, pillsContainer);
    } else {
      optionContainer.appendChild(wrap);
    }
  }

  function findAndBuild() {
    // Shrine renders options inside elements with data-option or similar
    // We look for any container that holds the option label matching OPTION_NAME
    var allOptionContainers = document.querySelectorAll(
      '.variant-picker__option, [data-variant-option], .product-variant-picker__option'
    );

    allOptionContainers.forEach(function (container) {
      var labelEl = container.querySelector(
        '.variant-picker__option-name, .variant-picker__label, [data-option-name]'
      );
      var labelText = labelEl ? labelEl.textContent.trim() : '';

      // Match "Ritual" anywhere in the label (case-insensitive)
      if (labelText.toLowerCase().indexOf(OPTION_NAME.toLowerCase()) === -1) return;

      var pills = Array.from(container.querySelectorAll(
        '.variant-picker__option-values--pills button, ' +
        '.variant-picker__option-values--pills [role="radio"], ' +
        '.variant-picker__pills button, ' +
        '[data-option-values] button'
      ));

      if (!pills.length) return;

      buildCards(container, pills);

      // Watch for Shrine updating pill states (e.g. URL-based variant selection)
      // and keep our card selected state in sync
      var observer = new MutationObserver(function () {
        var cards = container.querySelectorAll('.ritual-card-item');
        pills.forEach(function (pill, i) {
          var card = cards[i];
          if (!card) return;
          var isNowSelected = pill.classList.contains('active') ||
                              pill.getAttribute('aria-pressed') === 'true' ||
                              pill.classList.contains('selected') ||
                              pill.classList.contains('is-selected') ||
                              pill.getAttribute('aria-checked') === 'true';
          card.classList.toggle('is-selected', isNowSelected);
        });
      });

      pills.forEach(function (pill) {
        observer.observe(pill, { attributes: true, attributeFilter: ['class', 'aria-pressed', 'aria-checked'] });
      });
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', findAndBuild);
  } else {
    findAndBuild();
  }

  // Re-run if Shopify re-renders the section (theme editor)
  document.addEventListener('shopify:section:load', function () {
    setTimeout(findAndBuild, 100);
  });

  // Safety: retry once after 1s in case Shrine renders pills asynchronously
  setTimeout(findAndBuild, 800);

})();
